import {useEffect} from 'react'
import {Sync} from '@client/sync'
import {MessageBox} from '@components/message-box'
import {EventBus} from '../../client/event-bus'
import {
  CreateRepeatTemplateEventData,
  openRepeatTemplatesEvent
} from '../../client/events'
import {ChatUtils} from '../../extensions/chat-utils'
import {repeatStore} from './repeat-store'

export const useUpdateBoardId = (): void => {
  useEffect(() => {
    const handler = (data: CreateRepeatTemplateEventData): void => {
      if (!data.boardId || repeatStore.state.boardId === data.boardId) {
        return
      }

      ChatUtils.closeChatIfOpened()

      repeatStore.setBoardId(data.boardId)

      if (data.fromTaskId) {
        const task = Sync.getCurrentSandbox().getHub(data.fromTaskId)
        if (task && !repeatStore.create(task)) {
          return
        }
        repeatStore.setEditedFromId(data.fromTaskId)
      }

      if (data.templateId) {
        const box = Sync.getCurrentSandbox()
        const hub = box.getHub(data.templateId)
        if (!hub) {
          MessageBox.warn('Cannot open template')
          return
        }
        repeatStore.create(hub, true)
      }
    }

    EventBus.on(openRepeatTemplatesEvent, handler)
    return () => EventBus.off(openRepeatTemplatesEvent, handler)
  }, [repeatStore.state.boardId])
}
